export enum Severity {
    Fatal = "fatal",
    Error = "error",
    Warning = "warning",
    Log = "log",
    Info = "info",
    Debug = "debug",
}
export type SeverityLevel = "fatal" | "error" | "warning" | "log" | "info" | "debug";
